export default num => {
    const formatter = new Intl.NumberFormat('kz-KZ', {
        style: 'currency',
        currency: 'KZT',
    });

    return formatter.format(num);
}